import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { OsType } from 'mbs-ui-shared/src/lib/modules/schedule-group-action/components/select-action/select-action.component';
import { ScriptLibraryEntry } from 'mbs-ui-shared/src/lib/store/rmmScriptLibrary/model';
import * as ScriptLibrarySelectors from 'mbs-ui-shared@store/rmmScriptLibrary/selectors';

export enum ScriptType {
  Bash = 'Bash',
  Powershell = 'PowerShell'
}

@UntilDestroy()
@Component({
  selector: 'mbs-profile-notification-script-utility',
  templateUrl: './profile-notification-script-utility.component.html'
})
export class ProfileNotificationScriptUtility implements OnChanges {
  @Input() id = 0;
  @Input() scriptId: string = null;
  @Input() osType: OsType;
  @Input() osList = [];
  @Output() onChanges = new EventEmitter<{ utilityNumber: number; enabled: boolean; osType: string; scriptId: string }>();

  public scripts: ScriptLibraryEntry[] = [];
  public linuxMacScripts: ScriptLibraryEntry[] = [];
  public winScripts: ScriptLibraryEntry[] = [];

  public osTypes = OsType;

  public scriptForm: UntypedFormGroup = new UntypedFormGroup({
    enabled: new FormControl(true),
    osType: new FormControl(),
    scriptId: new FormControl()
  });

  constructor(private store: Store) {
    this.scriptForm.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => this.onChanges.emit({ ...value, id: this.id }));
    this.setupAvailableScripts();
  }

  setupAvailableScripts() {
    this.store
      .select(ScriptLibrarySelectors.selectAll)
      .pipe(untilDestroyed(this))
      .subscribe((scripts) => {
        this.scripts = [...scripts];
        this.winScripts = scripts.filter((script) => script.type === ScriptType.Powershell);
        this.linuxMacScripts = scripts.filter((script) => script.type === ScriptType.Bash);
        this.scriptForm.get('scriptId').setValue(this.scriptId, { emitEvent: false });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.osType)
      this.scriptForm.patchValue(
        {
          enabled: true,
          osType: this.osList.find((os) => os === this.osType),
          scriptId: this.scriptId ?? this.scriptForm.get('scriptId').value
        },
        { emitEvent: false }
      );
  }
}
